export default __webpack_public_path__ + "static/media/anzu.a54f9a17.csv";